export function filterRouter(routers) {
  // 遍历后台传来的路由字符串，转换为组件对象
  const accessedRouters = routers.filter(route => {
    const compoent = route.path.split("/").pop();
    // const compoent = route.path.split("/")[1];
    if (compoent) {
      route.component = _import(compoent);
    }
    if (route.children && route.children.length) {
      route.children = filterRouter(route.children);
    }
    return true;
  });
  return accessedRouters;
}

export function _import(file) {
  return () => import("@/views/" + file + ".vue");
  // return resolve => require([`@/views/${file}`], resolve);
}

export function fileInfo(routers) {
  routers.map(item => {
    item["icon"] = getQueryStringWell(item.path, "icon") || "icon-zhanweifu";
    item["path"] = item.path.split("?")[0];
    Object.keys(item).forEach(key => {
      if (
        key == "name" ||
        key == "path" ||
        key == "children" ||
        key == "id" ||
        key == "icon" ||
        key == "isShow"
      ) {
        // console.log();
      } else {
        delete item[key];
      }
    });
    if (item.children && item.children.length) {
      fileInfo(item.children);
    }
  });
  return routers;
}

export function getQueryStringWell(path, name) {
  let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  if (path.indexOf("?") < 0) {
    return null;
  }
  let r = path.split("?")[1].match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return null;
}

export function getQueryString(path, name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
  var r = path.match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}
